import { useEffect, useState } from "react";

export type VisualViewportBox = {
  offsetLeft: number;
  offsetTop: number;
  width: number;
  height: number;
};

function readVisualViewport(): VisualViewportBox {
  const vv = typeof window !== "undefined" ? window.visualViewport : null;
  if (!vv) {
    return {
      offsetLeft: 0,
      offsetTop: 0,
      width: typeof window !== "undefined" ? window.innerWidth : 0,
      height: typeof window !== "undefined" ? window.innerHeight : 0,
    };
  }
  return {
    offsetLeft: vv.offsetLeft,
    offsetTop: vv.offsetTop,
    width: vv.width,
    height: vv.height,
  };
}

/** Видимая область окна (учитывает клавиатуру / zoom на iOS). */
export function useVisualViewport(): VisualViewportBox {
  const [box, setBox] = useState(readVisualViewport);

  useEffect(() => {
    const vv = window.visualViewport;
    const update = () => setBox(readVisualViewport());
    update();
    window.addEventListener("resize", update);
    vv?.addEventListener("resize", update);
    vv?.addEventListener("scroll", update);
    return () => {
      window.removeEventListener("resize", update);
      vv?.removeEventListener("resize", update);
      vv?.removeEventListener("scroll", update);
    };
  }, []);

  return box;
}

/** Зажать прямоугольник в visualViewport (client coords). */
export function clampRectToVisualViewport(
  left: number,
  top: number,
  width: number,
  height: number,
  vv: VisualViewportBox,
  margin = 8
): { left: number; top: number } {
  const minL = vv.offsetLeft + margin;
  const minT = vv.offsetTop + margin;
  const maxL = Math.max(minL, vv.offsetLeft + vv.width - width - margin);
  const maxT = Math.max(minT, vv.offsetTop + vv.height - height - margin);
  return {
    left: Math.min(Math.max(minL, left), maxL),
    top: Math.min(Math.max(minT, top), maxT),
  };
}
